import { Locale } from "modules/i18n/locale-config";

export default {
  locale: Locale.SV.code,
  messages: {
    "app.save": "Spara",
    "app.print": "SKRIV UT",
    "app.previous": "Föregående",
    "app.next": "Nästa",
    "app.start": "Starta",
    "root.social-security-number": "ÅÅÅÅMMDDXXXX",
    "root.start-bank-id": "MOBILT BANKID",
    "app.continue": "Fortsätt",
    "app.got-it": "Uppfattat",
    "app.show-help": "Vägledning",
    "app.locale-en": "English",
    "app.locale-sv": "Svenska",
    "app.locale-is": "Icelandic",
    "root.brand": "Healo",
    "root.title": "Självskattning",
    "root.desc": `Välkommen att starta din resa mot smärtfrihet. <br/>Din Självskattning kommer att ta några minuter.`,
    "root.disclaimer":
      "© 2017-" +
      new Date()
        .getFullYear()
        .toString()
        .substr(-2) +
      " Empowered Applications",
    "root.start-diagnosis": "Starta",
    "root.start-diagnosis.email": "<b>Starta</b> med mejl",
    "root.sign-up": "Skapa konto",
    "root.go-home": "Till Start",
    "root.auth.or": "ELLER",
    "general-info.title": "Allmän info",
    "general-info-form.sex": "Kön",
    "general-info-form.male": "Man",
    "general-info-form.female": "Kvinna",
    "general-info-form.weight": "Vikt (kg)",
    "general-info-form.height": "Längd (cm)",
    "general-info-form.age": "Ålder",
    "general-info-form.first-name": "Förnamn",
    "general-info-form.last-name": "Efternamn",
    "general-info-form.country": "Land",
    "general-info-form.city": "Stad",
    "general-info-form.language": "Språk",
    "initial-diagnostic.title": "Inledande Självskattning",
    "locale-switcher.title": "Välj språk",
    "locale-switcher.title.epassi": "Språk",
    "body-model.rotate": "Rotera kroppen",
    "pain-profile.title": "Smärtprofil",
    "modal.instruction": "Instruktion",
    "modal.information": "Information",
    "general-info-form.error.sex": "Du måste välja kön.",
    "general-info-form.error.weight":
      "Du måste delge din vikt. Det är viktigt för att din behandling ska bli rätt.",
    "general-info-form.error.height":
      "Du måste delge din längd. Det är viktigt för att din behandling ska bli rätt.",
    "general-info-form.error.age":
      "Du måste delge din ålder. Det är viktigt för att din behandling ska bli rätt.",
    "general-info-form.error.first_name.special-characters":
      "Förnamn får endast innehålla bokstäver.",
    "general-info-form.error.first_name.length": "Du måste delge ditt förnamn.",
    "general-info-form.error.last_name.special-characters":
      "Efternamn får endast innehålla bokstäver.",
    "general-info-form.error.last_name.length":
      "Du måste delge ditt efternamn.",
    "general-info-form.i_am_a": "Jag är",
    "general-info-form.i_am": "Jag är",
    "general-info-form.i_am_born_on": "Jag är född",
    "general-info-form.years_old": "år gammal",
    "general-info-form.man": "Man",
    "general-info-form.woman": "Kvinna",
    "self-diagnostic.finished_desc":
      "Tack. Vi har en behandling till dig. Vänligen fortsätt för att skapa konto och spara din Självskattning. Därefter kan du ladda ner appen och påbörja din behandling.",
    "modal.thinking.text": "TÄNKER",
    "modal.question-changed.text":
      "Om du ändrar ditt svar på denna fråga kommer du att behöva besvara följande frågor igen. Vill du ändra ditt svar?",
    "modal.question-changed.approve": "Ja, ändra mitt svar",
    "modal.question-changed.decline": "Nej, behåll mitt svar",
    "modal.exit-diagnostic.text":
      "Är du säker på att du vill avbryta självskattningen? Dina svar kommer inte att sparas om du inte gör klart hela.",
    "modal.exit-diagnostic.approve": "JA, AVBRYT",
    "modal.exit-diagnostic.decline": "NEJ, FORTSÄTT",
    "modal.unexpected-error.text":
      "Det har skett ett oväntat tekniskt problem. Vänligen ladda om sidan.",
    "modal.unexpected-error.approve": "Ja, ladda om sidan",
    "sign-up.confirm": "Bekräfta",
    "sign-up.resend-code": "Skicka om kod",
    "sign-up.confirm-email.header": "Bekräfta din mejl",
    "sign-up.create-account.header": "Skapa konto",
    "sign-up.create-account.code_already_sent":
      "Bekräftelsekoden har redan skickats till din mejl",
    "sign-up.create-account.wrong_email":
      "Mejlen är redan använd på ett konto i Healo. Antingen provar du en annan mejladress eller så loggar du in på appen och uppdaterar din Självskattning där.",
    "sign-up.create-password.header": "Skapa ett lösenord",
    "sign-up.email": "Mejl",
    "sign-up.phone": "Telefon",
    "sign-up.password": "Lösenord",
    "sign-up.confirm-password": "Bekräfta lösenord",
    "sign-up.submit-password": "Skapa",
    "sign-up.code": "Bekräftelsekod",
    "sign-up.first-name": "Förnamn",
    "sign-up.last-name": "Efternamn",
    "sign-up.sign-up": "Skapa konto",
    "sign-up.sign-up-facebook": "Fortsätt med Facebook",
    "sign-up.finish_main": "Stort tack!",
    "sign-up.finish":
      "Allt är klart och du kan nu ladda ned appen Healo och logga in med ditt nya konto för att påbörja din behandling.",
    "sign-up.error.email": "Mejlen du har angett är ogiltig",
    "sign-up.error.code":
      "Bekräftelsekoden du har angett är ogiltig. Kolla din mejl igen.",
    "sign-up.error.password.missing": "Du måste skriva in ditt lösenord",
    "sign-up.error.password.missmatch": "Lösenorden matchar inte",
    "consent.title": "Informerat Samtycke",
    "consent.button": "Jag samtycker",
    "mobile-redirect.part1": "Vi ser att du använder en smartphone.",
    "mobile-redirect.part2":
      "Vänligen ladda ned Healo och genomför självskattningen direkt i appen!",
    "mobile-redirect.part3": "Tack!",
    "mobile-redirect-clinic.part1":
      "Tyvärr fungerar inte Självskattningen på en mobil eller liten surfplatta.",
    "mobile-redirect-clinic.part2":
      "Vänligen prova länken igen på en dator eller surfplatta med större skärm.",
    "mobile-redirect-clinic.part3": "Ursäkta detta, och tack för tålamodet!",
    "vas-slider.lvl_1": "Ingen smärta",
    "vas-slider.lvl_1_desc": "Mår bra.",
    "vas-slider.lvl_2": "Väldigt mild",
    "vas-slider.lvl_2_desc":
      "Hanterbar utan ansträngning, men alltmer medveten om besväret.",
    "vas-slider.lvl_3": "Obekväm",
    "vas-slider.lvl_3_desc":
      "Värkande och irriterande men stör inte de flesta dagliga aktiviteterna.",
    "vas-slider.lvl_4": "Uthärdlig",
    "vas-slider.lvl_4_desc":
      "Jag kan anpassa mig till smärtan psykiskt och/eller med medicinering.",
    "vas-slider.lvl_5": "Besvärande",
    "vas-slider.lvl_5_desc": "Påverkar väsentligen mina dagliga aktiviteter.",
    "vas-slider.lvl_6": "Väldigt besvärande",
    "vas-slider.lvl_6_desc":
      "Smärtan kräver livsstilsförändringar men jag är fortfarande oberoende.",
    "vas-slider.lvl_7": "Intensiv",
    "vas-slider.lvl_7_desc": "Jag kan inte anpassa mig till smärtan.",
    "vas-slider.lvl_8": "Väldigt intensiv",
    "vas-slider.lvl_8_desc":
      "Handikappande, jag kan inte utföra många dagliga aktiviteter.",
    "vas-slider.lvl_9": "Hemsk",
    "vas-slider.lvl_9_desc": "Jag kan inte alls utföra dagliga aktiviteter.",
    "vas-slider.lvl_10": "Plågsam och {break}outhärdlig smärta",
    "vas-slider.lvl_10_desc":
      "Jag är handikappad och kan inte längre fungera självständigt.",
    "vas-slider.lvl_11": "Otänkbar smärta",
    "vas-slider.lvl_11_desc":
      "Värsta tänkbara smärta, ord kan inte beskriva den.",
    "sign-up.error.password.short":
      "Ditt lösenord måste bestå av minst sex tecken.",
    "consent.desc":
      "Healo är en CE-certified app. Innan du kan gå vidare måste du <b>samtycka</b> till villkoren i <b>Medicinskt samtycke</b> samt godkänna våra <b>Användarvillkor</b> och vår <b>Integritetspolicy</b>.",
    "consent.checkbox.medical": " Medicinskt samtycke",
    "consent.checkbox.medical.description":
      "Healo är utformad för att erbjuda besvärspreventiva övningar och/eller hjälpa dig att uppnå minskad smärta genom egenvård av muskuloskeletala besvär. Healo ersätter inte professionell medicinsk rådgivning.",
    "consent.checkbox.terms": "Användarvillkor",
    "consent.checkbox.terms.description":
      "Genom att använda Healo accepterar du våra användarvillkor",
    "consent.checkbox.privacy": "Integritetspolicy",
    "consent.checkbox.privacy.description":
      "Genom att använda Healo samtycker du till vår behandling av dina personuppgifter och data. Healo försäkrar att all hantering och bearbetning av din data sker enligt EUs regelverk och internationell lag.",
    "sign-up.create-acc":
      "För att få tillgång till din behandling i mobilen behöver du skapa ett konto hos Healo.",
    "sign-up.check-email":
      "Vänligen kolla din email. Vi har skickat en verifieringskod till dig. Skriv in koden här i fältet.",
    "sign-up.create-password": "Nu ska du skapa ett lösenord.",
    "human.select-zones": "Markera dina smärtområden på modellen.",
    "human.select-zones-desctiption":
      "Om du har flera problemområden ska du utföra en Självskattning per område. Börja med det område som gör mest ont. Du kan skapa fler behandlingar senare genom att starta en ny Självskattning i appen.",
    "human.ok-button": "OK",
    "sex_and_age.weight_validation": "Vänligen fyll i din riktiga vikt.",
    "sex_and_age.height_validation": "Vänligen fyll i din riktiga längd.",
    "sex_and_age.required": "Detta fält är obligatoriskt.",
    "diagnosis_finished.text_rf":
      "Vi har analyserat dina svar och du har fått en Röd flagg vilket betyder att det var vissa indikatorer i Självskattningen som måste undersökas av professionell vårdgivare. För att säkerställa att du får bästa möjliga vård rekommenderar vi att du snarast möjligt uppsöker din ordinarie vårdgivare för att få problemet undersökt.",
    "diagnosis_finished.text_rf_extended":
      "Vänligen fortsätt med att skapa ett konto (nästa steg) för att spara resultatet av Självskattningen (dina svar och ditt resultat raderas annars) och sedan ladda ned appen och logga in (med ditt nya konto).{break}Vi rekommenderar att du visar din vårdgivare resultatet av din Självskattning i Healo när du träffar dem.{break}Om du har några frågor om din Självskattning eller resultatet, vänligen skapa kontot, ladda ned appen, logga in och hör sedan av dig till vår medicinska personal genom appens chat.",
    "diagnosis_finished.text_of":
      "Vi har analyserat dina svar och vi är glada att berätta att vi har en behandling redo för dig i Healo!",
    "diagnosis_finished.text_of_extended":
      "Men du har också fått Orange flagg vilket betyder att det var vissa indikatorer i Självskattningen som måste undersökas av professionell vårdgivare. För att säkerställa att du får bästa möjliga vård rekommenderar vi att du inom en veckas tid uppsöker din ordinarie vårdgivare för att undersöka problemet.{break}Det sagt är det bra att du har beslutat dig för att ta tag i ditt problem. Förhoppningsvis kan några genomförda pass rehab förmildra dina symptom medan du väntar på att träffa din vårdgivare.{break}Vänligen fortsätt med att skapa ett konto (nästa steg) för att spara resultatet av Självskattningen (dina svar och ditt resultat raderas annars) och sedan ladda ned appen och logga in (med ditt nya konto).{break}Vi rekommenderar att du visar din vårdgivare resultatet av din Självskattning i Healo när du träffar dem.{break}Om du har några frågor om din Självskattning eller resultatet, vänligen skapa kontot, ladda ned appen, logga in och hör sedan av dig till vår medicinska personal genom appens chat.",
    "diagnosis_finished.text_l_yf":
      "Vi har analyserat dina svar och vi är glada att berätta att vi har en behandling redo för dig i Healo!",
    "diagnosis_finished.text_l_yf_extended":
      "Men du har också fått Gul flagg vilket betyder att din Självskattning indikerar faktorer i ditt liv som kan leda till att du utvecklar långvariga besvär eller att din rehabilitering tar längre tid. Dessa faktorer kan omfatta ditt allmänna hälsotillstånd, dina stress- eller sömnmönster, med flera. Du kommer att få mer information om detta i appen.{break}Det sagt är det mycket bra att du har beslutat dig för att ta tag i ditt problem nu, vilket sannolikt kan leda till att dessa faktorer inte utvecklas åt fel håll.{break}Vänligen fortsätt med att skapa ett konto (nästa steg) för att spara resultatet av Självskattningen (dina svar och ditt resultat raderas annars) och sedan ladda ned appen och logga in (med ditt nya konto).{break}Om du har några frågor om din Självskattning eller resultatet, vänligen skapa kontot, ladda ned appen, logga in och hör sedan av dig till vår medicinska personal genom appens chat.",
    "diagnosis_finished.text_q_yf":
      "Vi har analyserat dina svar och vissa indikatorer i Självskattningen måste undersökas i mer detalj innan vi kan skapa en behandling för dig. Du kan nu välja att antingen ladda om denna sida och göra en Utförlig Självskattning eller skapa ett konto i Healo (nästa steg) för att spara resultatet av den nuvarande Självskattningen (dina svar och ditt resultat raderas annars) och sedan ladda ned appen och logga in (med ditt nya konto).{break}När du har installerat och startat Healo kan du navigera till Smärtprofil och klicka knappen Lägg till behandling och göra den Utförliga Självskattningen för att få reda på om du kan påbörja din behandling direkt eller behöver uppsöka vården och hur bråttom det är.{break}Om du har några frågor om din Självskattning eller resultatet, vänligen skapa kontot, ladda ned appen, logga in och hör sedan av dig till vår medicinska personal genom appens chat..",
    "diagnosis_finished.text_q_yf_extended": " ",
    "diagnosis_finished.text_default":
      "Vi har analyserat dina svar och vi är glada att berätta att vi har en behandling redo för dig i Healo!{break}Vänligen fortsätt med att skapa ett konto (nästa steg) för att spara resultaten av Självskattningen (dina svar och ditt resultat raderas annars) och sedan ladda ned appen, logga in (med ditt nya konto) och påbörja din behandling!",
    "diagnosis_finished.text_default_extended":
      "Om du har några frågor om din Självskattning eller resultatet, vänligen skapa kontot, ladda ned appen, logga in och hör sedan av dig till vår medicinska personal genom appens chat.",
    "diagnosis_finished.proceed": "Fortsätt",
    "self-diagnostic.finished":
      "Tack för att du har genomfört Självskattningen!",
    "self-diagnostic.finished_q_yf": "Kort Självskattning är inte tillräcklig.",
    "consent-modal.i_consent": "Samtyck",
    "sign-up-clinic.finish":
      "Allt är klart och din vårdenhet har meddelats om dina resultat.",
    "sign-up-clinic.finish_2":
      "Du kan nu ladda ned appen Healo och logga in med ditt nya konto för att påbörja din behandling.",
    "sign-up-clinic.finish_3":
      "Din vårdgivare kommer att höra av sig i Healos chatt.",
    "sign-up.error.clinic_city": "Välj din klinik",
    "sign-up.clinic_city_default": "Välj din klinik",
    "bank_id.error_400": "Ett tekniskt fel har inträffat",
    "root.loading": "Verifierar",
    "root.check_your_device": "Öppna din<br/>BankID app",
    "ssn_validation.empty-ssn":
      "Vänligen ange personnummer med 12 siffor (ÅÅÅÅMMDDXXXX)",
    "ssn_validation.ssn-too-long":
      "Vänligen ange personnummer med 12 siffor (ÅÅÅÅMMDDXXXX)",
    "ssn_validation.ssn-too-short":
      "Vänligen ange personnummer med 12 siffor (ÅÅÅÅMMDDXXXX)",
    "bank_id.error_406": "Användare är redan registrerad",
    "root.identify-bank-id": "Identifiera dig med BankID",
    "root.identify-bank-id--description":
      "Starta BankID-appen och skanna QR-koden.",
    "root.open-bank-id--device": "Öppna BankID på den här enheten istället"
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/default/messages/sv.js